import type {ChannelId, Message} from "./chat";

export const CHAT_MESSAGE_CREATE = "CREATE";
export const CHAT_MESSAGE_UPDATE = "UPDATE";
export const CHAT_MESSAGE_DELETE = "DELETE";
export const CHAT_MESSAGE_PIN = "PIN";
export const CHAT_ACTIVE_USERS = "ACTIVE_USERS";

type MessageAction = {
    actionType:
        | typeof CHAT_MESSAGE_CREATE
        | typeof CHAT_MESSAGE_UPDATE
        | typeof CHAT_MESSAGE_DELETE
        | typeof CHAT_MESSAGE_PIN;
    comment: Message;
};

type ActiveUsersAction = {
    actionType: typeof CHAT_ACTIVE_USERS;
    data: {
        channelId: ChannelId;
        numberOfActiveUsers: number;
    };
};

export type ChatPushAction = MessageAction | ActiveUsersAction;
